import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'statusClass',
  pure: true // This makes it a pure pipe for better performance
})
export class StatusClassPipe implements PipeTransform {
  transform(status: string): string {
    if (!status) {
      return 'status-sent';
    }
    
    switch (status.toLowerCase()) {
      case 'sent':
        return 'status-sent';
      case 'delivered':
        return 'status-delivered';
      case 'read':
        return 'status-read';
      default:
        return 'status-sent';
    }
  }
}
